import React from "react";
import Properties from "../common/properties/Properties";
 function PropertiesComponent() {
  return (
    <div className=" max-w-[1440px] m-auto md:px-6 px-4 ">
<div className="pt-[83px]">
    <Properties />
</div>
    </div>
  );
}

export default PropertiesComponent;